export default {
  colorize: true,
  showColorLegend: false
};